module.exports = __webpack_public_path__ + "static/media/blueReceipt.c18a4032.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueReceipt.svg
// module id = 453
// module chunks = 0